import {
  addResource,
  deleteResource,
  fetchResource,
  putResource,
  updateResource,
  updateImgResource,
  uploadZip,
} from "signoxe/actions/remote";
import {
  ASSETS_RESOURCE,
  CALENDAR_RESOURCE,
  FEED_RESOURCE,
  WEB_RESOURCE,
  URL_RESOURCE,
  AQI_RESOURCE,
  FIDS_RESOURCE,
  AQI_VEDA_RESOURCE,
  IMAGE_RESOURCE,
  AUDIO_RESOURCE,
  VIDEO_RESOURCE,
  ZIP_RESOURCE,
  CAMPAIGN_RESOURCE,
  QUIZ_RESOURCE,
} from "signoxe/api/resources";
import { FILTER_ASSETS, SEARCH_ASSETS } from "signoxe/constants/actionTypes";

export const fetchCampaigns = fetchResource(CAMPAIGN_RESOURCE);
export const fetchAssets = fetchResource(ASSETS_RESOURCE);
export const fetchPagedAssets = (url) =>
  fetchResource(ASSETS_RESOURCE, false, url)();
export const updateAsset = updateResource(ASSETS_RESOURCE);
export const deleteAsset = deleteResource(ASSETS_RESOURCE);

export const updateImageAsset = updateImgResource(IMAGE_RESOURCE);
export const updateAudioAsset = updateImgResource(AUDIO_RESOURCE);
export const updateVideoAsset = updateImgResource(VIDEO_RESOURCE);

export const setAssetTags = putResource({
  resource: ASSETS_RESOURCE,
  subResource: "tags",
  route: "detail",
});

export const fetchWebAssets = fetchResource(WEB_RESOURCE);
export const fetchWebAsset = fetchResource(WEB_RESOURCE, true);
export const updateWebAsset = updateResource(WEB_RESOURCE);
export const addWebAsset = addResource(WEB_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const fetchUrlAssets = fetchResource(URL_RESOURCE);
export const updateUrlAsset = updateResource(URL_RESOURCE);
export const addUrlAsset = addResource(URL_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const fetchAQIAssets = fetchResource(AQI_RESOURCE);
export const updateAQIAsset = updateResource(AQI_RESOURCE);
export const addAQIAsset = addResource(AQI_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const fetchAQIVedaAssets = fetchResource(AQI_VEDA_RESOURCE);
export const updateAQIVedaAsset = updateResource(AQI_VEDA_RESOURCE);
export const addAQIVedaAsset = addResource(AQI_VEDA_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const updateQuizAsset = updateResource(QUIZ_RESOURCE);
export const addQuizAsset = addResource(QUIZ_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const addZipAsset = uploadZip(ZIP_RESOURCE);

export const fetchCalendarAssets = fetchResource(CALENDAR_RESOURCE);
export const updateCalendarAsset = updateResource(CALENDAR_RESOURCE);
export const refreshCalendarAsset = addResource(CALENDAR_RESOURCE, "refresh");
export const addCalendarAsset = addResource(CALENDAR_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const fetchFidsAssets = fetchResource(FIDS_RESOURCE);
export const updateFidsAsset = updateResource(FIDS_RESOURCE);
export const addFidsAsset = addResource(FIDS_RESOURCE, undefined, {
  success: "Asset has been saved.",
});

export const fetchFeedAssets = fetchResource(FEED_RESOURCE);

export const searchAssets = (query) => ({ type: SEARCH_ASSETS, query });

export const filterAssetsByType = (type) => ({
  type: FILTER_ASSETS,
  filterBy: "TYPE",
  filter: type,
});

export const filterAssetsByAspect = (aspect) => ({
  type: FILTER_ASSETS,
  filterBy: "ASPECT",
  filter: aspect,
});

export const filterAssetsByTag = (tag) => ({
  type: FILTER_ASSETS,
  filterBy: "TAGS",
  filter: tag,
});



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/asset.js